<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editSp" ref="editSpRef" label-width="170px">
          <el-form-item label="IP" class="addAdminForm">
            <el-input v-model="editSp.ip" disabled></el-input>
          </el-form-item>
          <el-form-item label="国家" class="addAdminForm">
            <el-input v-model="editSp.country"></el-input>
          </el-form-item>
          <el-form-item label="区域" class="addAdminForm">
            <el-input v-model="editSp.region"></el-input>
          </el-form-item>
          <el-form-item label="省" class="addAdminForm">
            <el-input v-model="editSp.province"></el-input>
          </el-form-item>
          <el-form-item label="市" class="addAdminForm">
            <el-input v-model="editSp.city"></el-input>
          </el-form-item>
          <el-form-item label="ISP" class="addAdminForm">
            <el-input v-model="editSp.isp"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editSp: {
        ip: '',
        country: '',
        region: '',
        province: '',
        city: '',
        isp: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editSp.ip = row.Ip
      this.editSp.country = row.Country
      this.editSp.region = row.Region
      this.editSp.province = row.Province
      this.editSp.city = row.City
      this.editSp.isp = row.Isp
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditIpAddress()
    },
    apiEditIpAddress: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ip: that.editSp.ip,
        country: that.editSp.country,
        region: that.editSp.region,
        province: that.editSp.province,
        city: that.editSp.city,
        isp: that.editSp.isp
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditIpAddress, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.$emit('triggerFunc', '')
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
